exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CodeActivation{margin:0 auto;width:288px}.CodeActivation-headerImage{width:100%}.CodeActivation-header{font-size:24px;font-weight:500;margin-top:16px;margin-bottom:42px}.CodeActivation-header-sub{font-size:16px;font-weight:400;margin-top:8px}.CodeActivation-header-small{font-size:20px;font-weight:500;margin-bottom:16px}.CodeActivation .TextField{margin-bottom:16px}", ""]);

// exports
